/* Sección de historia del café: la bolsa entra desde la derecha y el texto sube
   desde abajo a medida que la sección se revela, y toda la capa de ondas se corre
   un poco con el scroll.

   Solo se escriben dos variables CSS; el movimiento lo resuelve el CSS:
     --phistoria-entrada : 0 a 1, cuánto se ha revelado la sección
     --phistoria-avance  : -1 a 1, posición respecto al centro de la pantalla */
(() => {
  const montar = (seccion) => {
    seccion.dataset.listo = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    seccion.style.setProperty('--phistoria-entrada', '0');

    let visible = false;
    let pendiente = false;

    const actualizar = () => {
      pendiente = false;
      const r = seccion.getBoundingClientRect();
      const alto = window.innerHeight || 1;

      // la revelación arranca cuando el borde de arriba entra y termina a media pantalla
      const recorrido = Math.min(alto * 0.55, r.height);
      const avanzado = alto - r.top - alto * 0.18;
      const entrada = Math.max(0, Math.min(1, avanzado / Math.max(recorrido, 1)));
      seccion.style.setProperty('--phistoria-entrada', entrada.toFixed(3));

      const centro = r.top + r.height / 2;
      const avance = Math.max(-1, Math.min(1, (centro - alto / 2) / (alto / 2 + r.height / 2)));
      seccion.style.setProperty('--phistoria-avance', avance.toFixed(3));
    };

    const alScroll = () => {
      if (!visible || pendiente) return;
      pendiente = true;
      requestAnimationFrame(actualizar);
    };

    new IntersectionObserver((entradas) => {
      visible = entradas[0].isIntersecting;
      if (visible) actualizar();
    }, { threshold: 0 }).observe(seccion);

    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll, { passive: true });
    actualizar();
  };

  const init = () => document.querySelectorAll('[data-historia]:not([data-listo])').forEach(montar);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
